import {Logger} from '@wix/bi-logger-pre';
import {
  BricksBiService,
  BricksFedopsService,
  createBiConsoleAdapter,
  createBiWixPremiumAdapter,
  createFedopsWixAdapter,
} from '@wix/premium-bricks-services';

import type {Services} from './ServicesProvider';

export const createServices = (): Services => {
  const fedopsLoggerService = new BricksFedopsService<{}, {}>({
    adapter: createFedopsWixAdapter(window.__STATICS_APP_NAME__),
  });

  const biLoggerService = new BricksBiService<Logger>({
    adapter: window.__DEBUG__ ? createBiConsoleAdapter() : createBiWixPremiumAdapter(),
  });

  return {
    fedopsLoggerService,
    biLoggerService,
  };
};
